import { storyblokEditable } from "@storyblok/react";

const BrandsHeaderPaulaner = ({ blok }) => (
  <div className="wrap">
    <div
      className="brandsheaderpaulaner-wrap inner-wrap flex items-center"
      {...storyblokEditable(blok)}
    >
      <div className="brandsheaderpaulaner-wrap-content flex">
        <div className="brandsheaderpaulaner-left">
          {/*     <img src={blok.logo.filename} alt={blok.logo.alt} /> */}
          <div className="brandsheaderpaulaner-img-box">
            <img
              className="brandsheaderpaulaner-logo hide-mobile"
              src={blok.logo.filename}
              alt={blok.logo.alt}
            />
            <img
              className="brandsheaderpaulaner-logo hide-desktop"
              src={blok.logo.filename}
              alt={blok.logo.alt}
            />
          </div>
          <h2 className="brandsheaderpaulaner-branding text-2xl">
            {blok.slogan}
          </h2>
          <div>
            <img
              className="brandsheaderpaulaner-mobileimg hide-mobile"
              style={{ display: `${blok.hideImage}` }}
              src={blok.image.filename}
              alt={blok.image.alt}
            />
            <div className="brandsheader-iframe-mobile-outer hide-mobile">
              <iframe
                style={{ display: `${blok.hideVideo}` }}
                className="brandsheader-iframe-mobile"
                src={blok.video}
                frameBorder="0"
                allow="autoplay; fullscreen; picture-in-picture"
                allowFullScreen
                title="PA_Akquisefilm V22"
              ></iframe>
            </div>
          </div>

         {blok.infotext && (<p className="brandsheaderpaulaner-infotext pb-3">{blok.infotext}</p>)} 
         {blok.infotext2 && (<p className="brandsheaderpaulaner-infotext pb-3">{blok.infotext2}</p>)} 
         {blok.infotext3 && (<p className="brandsheaderpaulaner-infotext pb-3">{blok.infotext3}</p>)} 
         {blok.infotext4 && (<p className="brandsheaderpaulaner-infotext pb-3">{blok.infotext4}</p>)} 
         {blok.infotext5 && (<p className="brandsheaderpaulaner-infotext">{blok.infotext5}</p>)} 

        </div>
        <div className="brandsheaderpaulaner-right ml-16">
          <img
            className="hide-desktop brandsheaderpaulaner-rightimage"
            style={{ display: `${blok.hideImage}` }}
            src={blok.image.filename}
            alt={blok.image.alt}
          />

          <iframe
            style={{ display: `${blok.hideVideo}` }}
            className="hide-desktop brandsheader-iframe"
            src={blok.video}
            frameBorder="0"
            allow="autoplay; fullscreen; picture-in-picture"
            allowFullScreen
            title="PA_Akquisefilm V22"
          ></iframe>
        </div>
      </div>
    </div>
  </div>
);
export default BrandsHeaderPaulaner;
